var _rect, _path, _rect2, _path2, _rect3, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventDescIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#EFF2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.136 9.072 2.467 1.957c.394.312.969-.023.911-.53l-.158-1.403a3.825 3.825 0 0 1 2.775.817c1.423 1.131 1.88 3.113 1.144 4.78a.288.288 0 0 0 .081.346l1.054.835a.28.28 0 0 0 .425-.097c1.277-2.494.69-5.614-1.54-7.382a5.66 5.66 0 0 0-4.156-1.196L29.004 6a.558.558 0 0 0-1.001-.278l-1.959 2.544a.578.578 0 0 0 .091.805ZM12.66 30.042l2.712 1.588a.577.577 0 0 1 .2.785l-1.59 2.795a.557.557 0 0 1-1.03-.133l-.298-1.167a5.646 5.646 0 0 1-4.279-.598c-2.45-1.436-3.46-4.442-2.538-7.093a.282.282 0 0 1 .407-.156l1.16.679a.287.287 0 0 1 .127.33c-.5 1.756.224 3.653 1.788 4.572.871.511 1.88.657 2.86.417l-.35-1.366c-.125-.494.398-.907.83-.653Z",
    fill: "#A4B2CF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.013 14.55c-.003.075-.003.148-.003.224v.45c0 .076 0 .15.003.225h-.423c-.465 0-.84.402-.84.9s.375.9.84.9h.743c.777 2.36 2.88 4.05 5.347 4.05h.63c.465 0 .84-.402.84-.9s-.375-.9-.84-.9h-.63c-1.52 0-2.84-.911-3.515-2.25h3.305c.465 0 .84-.402.84-.9s-.375-.9-.84-.9h-3.775a6.332 6.332 0 0 1-.005-.225v-.45c0-.076.003-.152.005-.225h3.775c.465 0 .84-.402.84-.9s-.375-.9-.84-.9h-3.305c.675-1.338 1.995-2.25 3.515-2.25h.63c.465 0 .84-.402.84-.9s-.375-.9-.84-.9h-.63c-2.467 0-4.57 1.69-5.347 4.05h-.743c-.465 0-.84.402-.84.9s.375.9.84.9h.423Z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 15.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#4965A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.021 19.1c.477 0 .862.385.862.862v.962c.043.005.084.01.127.018l.03.006 1.293.237a.862.862 0 0 1-.31 1.695l-1.28-.235c-.843-.124-1.587-.04-2.11.167-.522.208-.732.493-.78.757-.054.289-.014.45.032.55.048.105.148.224.345.356.439.288 1.112.476 1.985.708l.078.022c.77.205 1.714.452 2.414.91.383.251.744.59.967 1.065.23.482.278 1.02.173 1.595-.186 1.024-.892 1.708-1.768 2.066a4.5 4.5 0 0 1-1.196.297v.9a.861.861 0 1 1-1.724 0v-.94c-.01-.003-.024-.003-.035-.006h-.005c-.658-.103-1.738-.386-2.465-.709a.862.862 0 0 1 .7-1.573c.563.25 1.49.498 2.026.582.86.126 1.568.054 2.047-.143.456-.186.663-.455.723-.779.05-.285.01-.45-.035-.55-.052-.107-.151-.226-.35-.358-.443-.288-1.119-.477-1.994-.708l-.076-.02c-.768-.21-1.71-.46-2.411-.918-.383-.25-.74-.593-.964-1.067-.227-.482-.273-1.021-.165-1.595.194-1.029.965-1.697 1.84-2.045.359-.143.752-.24 1.164-.296v-.951c0-.477.385-.862.862-.862Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 25.063,
    y1: 27.25,
    x2: 7.552,
    y2: 4.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#778CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4B2CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDescIcon);
export default __webpack_public_path__ + "static/media/event_desc_icon.29582c49c25f227047f92b357e8abddb.svg";
export { ForwardRef as ReactComponent };